export default __webpack_public_path__ + "static/media/promo-2.a7eaf784.png";